module.exports = __webpack_public_path__ + "img/bond-rest-money.7eb76457.svg";